export const NOTIFICATION_TOPIC_EMNE_ALIASES: Record<string, string> = {
  "Calorie calculator / meal plan": "Kalorieberegner/Kostplan",
  "Campaigns & discounts": "Kampagner & rabatter",
  Cancellation: "Annullering",
  Compatability: "Kompatabilitet",
  Compatibility: "Kompatabilitet",
  Complaint: "Reklamation",
  Contact: "Kontakt",
  "Customer service": "Kundeservice",
  Delivery: "Levering",
  Discount: "Tilbud",
  "Fitness advice": "Fitness rådgivning",
  General: "Generel",
  "Information request": "Informationsforespørgsel",
  Kompatibilitet: "Kompatabilitet",
  Medlemskap: "Medlemskab",
  membership: "Medlemskab",
  Membership: "Medlemskab",
  Offer: "Tilbud",
  "Opening hours": "Åbningstider",
  Order: "Ordre",
  order: "Ordre",
  Ordering: "Bestilling",
  Other: "Andet",
  Payment: "Betaling",
  "Price and discount": "Pris og rabat",
  "Problem with the shop": "Problem med shoppen",
  "Product information": "Produktinformation",
  "Product recommendation": "Produkt anbefaling",
  Profile: "Profil",
  Refund: "Refundering",
  Return: "Returnering",
  "Right of withdrawal": "Fortrydelsesret",
  "Self-service wash": "Vask selv",
  Shipping: "Levering",
  "shop error": "Fejl på shoppen",
  "Shop error": "Fejl på shoppen",
  "Stock availability": "Lagerstatus",
  Stores: "Butikker",
  "Subscription & membership": "Abonnement & medlemskab",
  Technical: "Teknisk",
  Warranty: "Garanti",
};
